module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-540.e6c6d90.woff2";